import styles from './PlanCard.module.scss'

import Button from '@/components/Button'
import PurchaseTerms from '@/components/PurchaseTerms'
import { ENTERPRISE_NOTETAKER_NOTE, ENTERPRISE_SALES_FEATURES } from '@/constants/planFeatures'
import { useAnalytics } from '@/hooks/useAnalytics'
import { GreenTick } from '@/pages/auth/PlanCard'
import { EventName, PLATFORM_ADMIN_PORTAL } from '@/utils/eventDefinitions'

export const TALK_TO_SALES_URL = 'https://wisprflow.ai/talk-to-sales'

// Sales-led Enterprise card shown next to the self-serve cards once the
// Business relabel is live: no self-serve price, contact sales instead.
// `reserveAnnualSlot` only pads the price block so the divider lines up with priced cards on Annual.
const EnterpriseContactCard = ({
  location = 'billing_enterprise_card',
  reserveAnnualSlot = false,
  reservePurchaseTermsSlot = false,
}: {
  location?: string
  reserveAnnualSlot?: boolean
  reservePurchaseTermsSlot?: boolean
}) => {
  const { trackEvent } = useAnalytics()
  return (
    <div className={styles.planCard}>
      <h6 className={styles.heading}>Enterprise</h6>
      <div className={styles.price}>
        <span>Custom pricing</span>
        {reserveAnnualSlot && <div className={styles.annualDisclaimer} aria-hidden="true" />}
      </div>
      <div className={styles.planDivider}></div>
      <div className={styles.featureList}>
        <div className={styles.featureItem}>Everything in Growth, plus:</div>
        {ENTERPRISE_SALES_FEATURES.map((feature) => (
          <div key={feature} className={styles.featureItem}>
            <GreenTick />
            {feature}
          </div>
        ))}
        <div className={styles.footnote}>{ENTERPRISE_NOTETAKER_NOTE}</div>
      </div>
      <Button
        title="Talk to sales"
        onClick={() => {
          trackEvent?.(EventName.TalkToSalesClicked, { location, platform: PLATFORM_ADMIN_PORTAL })
          // noopener without noreferrer, deliberately: the marketing site reads the
          // referrer for attribution of sales-intent clicks.
          window.open(TALK_TO_SALES_URL, '_blank', 'noopener')
        }}
        type="dark"
      />
      {reservePurchaseTermsSlot && <PurchaseTerms placeholder />}
    </div>
  )
}

export default EnterpriseContactCard
